import { whenDocumentReady } from '../../../../../paws/assets/frontend/js/helper/documentready';
import { detectBreakpoint } from '../../../../../paws/assets/frontend/js/helper/breakpoint';
import Litepicker from 'litepicker';

whenDocumentReady(initModule);
function initModule() {
    let targetElement = document.getElementById('adadatarange');
    let currentBreakpoint = detectBreakpoint()
    let numberMonths = 1;
    if (currentBreakpoint == 'xxl' || currentBreakpoint == 'xl') {
        numberMonths = 3;
    }

    const picker = new Litepicker({
        element: targetElement,
        format: 'DD.MM.YYYY',
        lang: 'de-DE',
        singleMode: false,
        numberOfMonths: numberMonths,
        numberOfColumns: numberMonths,
        switchingMonths: 1,
        maxDate: new Date(targetElement.dataset.maxdate * 1000),
        minDate: new Date(targetElement.dataset.mindate * 1000),
        autoRefresh: true,
    });
    picker.on('selected', (date1, date2) => {
        htmx.trigger(targetElement, 'change');
    });
}
